


export default function Footer() {

  return (
      <footer className="footer">
        <p>© 2019–2025 International Chief Marketing Officer Summit Awards. Все права защищены.</p>
      </footer>
);
}
